export const RESPONSIVE_SPACINGS_CONFIG = { sx: 24, sm: 20, lg: 16, xl: 12 };
